var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getJson, postObjectJson } from '../utility/request';
import { Instant } from '../utility/datetime';
const parseBay = (bay) => (Object.assign(Object.assign({}, bay), { 'created': Instant.parse(bay.created), 'deactivated': bay.deactivated === null ? null : Instant.parse(bay.deactivated) }));
const parseAssignment = (a) => (Object.assign(Object.assign({}, a), { 'assigned': Instant.parse(a.assigned) }));
export const fetchServiceBayBoard = (merchantId) => __awaiter(void 0, void 0, void 0, function* () {
    const board = yield getJson(`/service-bays/${merchantId}`);
    return {
        'bays': board.bays.map(parseBay),
        'assignments': board.assignments.map(parseAssignment),
    };
});
export const createServiceBay = (merchantId, name) => postObjectJson(`/service-bays/${merchantId}`, { 'name': name });
export const renameServiceBay = (merchantId, bayId, name) => postObjectJson(`/service-bays/${merchantId}/${bayId}/update`, { 'name': name });
export const deleteServiceBay = (merchantId, bayId) => postObjectJson(`/service-bays/${merchantId}/${bayId}/delete`, {});
export const assignInvoiceToBay = (merchantId, invoiceId, bayId) => postObjectJson(`/service-bays/${merchantId}/assignments/${invoiceId}`, { 'bay_id': bayId });
export const unassignInvoiceFromBay = (merchantId, invoiceId) => postObjectJson(`/service-bays/${merchantId}/assignments/${invoiceId}/delete`, {});
